import React, { useMemo } from 'react';
import { Form } from 'react-final-form';

import { InfoDialog } from '@occc/ui-design-system';
import { Adjust_Points_Mathematical_Function } from '@occc/graphql';

import UpdatePointsModalForm from './UpdatePointsModalForm';
import { UpdatePointsModalFormFields } from './types';
import { getUpdatePointsValidation } from './validation';

export interface IUpdatePointsModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (inputs: UpdatePointsModalFormFields) => void;
  customerUuid?: string | null;
  maxAdjustmentValue: number | null;
}

const UpdatePointsModal: React.FC<IUpdatePointsModalProps> = ({
  show,
  onHide,
  onSubmit,
  customerUuid,
  maxAdjustmentValue,
}) => {
  const initialValues: Partial<UpdatePointsModalFormFields> = {
    mathematicalFunction: Adjust_Points_Mathematical_Function.IncreasePointOperation,
  };

  const validation = useMemo(
    () => getUpdatePointsValidation(maxAdjustmentValue),
    [maxAdjustmentValue],
  );

  return (
    <InfoDialog dialogTitle='Update Points Balance' onClose={onHide} open={show} fullWidth>
      <Form<UpdatePointsModalFormFields>
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validation}
        render={(props) => (
          <UpdatePointsModalForm
            {...props}
            onHide={onHide}
            customerUuid={customerUuid}
            isAdjustmentReasonSelected={Boolean(props.values.adjustmentReasonId)}
            onAdjustmentReasonClearClick={() => props.form.change('adjustmentReasonId', null)}
          />
        )}
      />
    </InfoDialog>
  );
};

export default UpdatePointsModal;
